<template>
  <div class="order-history-article align-center" :class="{'special': isSpecialItem}">
    <div class="image" v-if="!isSpecialItem">
      <ArticleImage :article="article" />
    </div>

    <div class="name">
      <ArticleCaption :article="article" v-if="!isSpecialItem" />
      <span v-else>{{ article.name }}</span>
    </div>

    <div class="shipped" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.shipped'))">
      <template v-if="article.doc_delivery_to_send && !isSpecialItem">
        {{ article.doc_delivery_to_send }} / {{ article.doc_delivery_sent }}
      </template>
      <template v-else>
        &nbsp;
      </template>
    </div>

    <div class="unit" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.unit'))">
      {{ article.unit }}
    </div>

    <div class="quantity" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.quantity'))">
       <span v-if="!isSpecialItem">
          {{ article.quantity }}
        </span>
    </div>

    <div class="price" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.price'))">
      <span v-if="!isSpecialItem">
        {{ getPrice(article) }}
      </span>
    </div>

    <div class="row-total" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.row-total'))">
      {{ getRowTotal(article) }}
    </div>

    <div class="status" :data-mobile-label="cleanLineBreaks($t('sl.order-history.headers.status'))">
      <span v-if="!isSpecialItem">
         {{ article.doc_status ? article.doc_status : "in Bearbeitung" }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ArticleImage from "../../Article/ArticleImage.vue";
import ArticleCaption from "../../Article/ArticleCaption.vue";
import { cleanLineBreaks } from "@/utils/String";

export default {
  name: "OrderHistoryArticle",
  components: { ArticleCaption, ArticleImage },

  props: {
    article: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      specialItemIds: ["logistic_surcharge", "9931012"]
    };
  },

  computed: {
    ...mapGetters({
      images: "bilder/produktbilder"
    }),


    isSpecialItem() {
      return this.specialItemIds.includes(this.article.internalID);
    }
  },

  methods: {
    cleanLineBreaks,
    getPrice(article) {
      if (!article.price_formatted) {
        return "";
      }
      return article.price_formatted
    },

    getRowTotal(article) {
      if (!article.total_price_formatted) {
        return "";
      }
      return article.total_price_formatted
    }

  }
};
</script>
